import React from 'react'
import { withTranslation } from 'react-i18next'
import Input from 'components/Input'
import { UilArrowLeft } from '@iconscout/react-unicons'
import Btn, { FormBtn } from 'components/Btn'
import { ArrowRight } from 'lucide-react'

export default withTranslation()(function ForgotPasswordForm({ t, yupFields: { isDirty, isValid }, sent, email }) {

  if (sent) {
    return (
      <div className="w-full text-center">
        <div className="text-6xl mb-6">📧</div>
        <h1 className="text-2xl font-bold text-black mb-1">{t('registration.forgot_password.check_title')}</h1>
        <p className="text-secondary mb-8">
          {t('registration.forgot_password.check_content')} <span className="font-semibold text-black">{email}</span> {t('registration.forgot_password.check_content_end')}
        </p>

        <Btn
          content={t('registration.forgot_password.resend')}
          variant="outline"
          color="#1976D2"
          className="w-full h-12 !rounded-full !border !border-border-lines"
          click={() => window.history.back()}
        />

        <div className="mt-4">
          <Btn
            content={() => <p className="text-primary flex font-semibold items-center justify-center"><UilArrowLeft size={18} className="mr-1" /> {t('misc.back')}</p>}
            click={() => window.history.back()}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="w-full text-center">
      <div className="text-left mb-6">
        <Btn
          content={() => <p className="text-primary flex font-semibold items-center">
            <UilArrowLeft size={18} className="mr-1" /> {t('misc.back')}
          </p>}
          className="!rounded-full !border !border-border-lines !px-4"
          variant="outline"
          color="#1976D2"
          click={() => window.history.back()}
        />
      </div>

      <h1 className="text-2xl font-bold text-black mb-1">{t('registration.forgot_password.title')}</h1>
      <p className="text-secondary mb-8">{t('registration.forgot_password.content')}</p>

      <div className="mb-8 text-left">
        <Input
          name="email"
          label={t('registration.forgot_password.email_label')}
          placeholder={t('registration.field.bmail_placeholder')}
          type="email"
          classList="!bg-white !border-border-lines rounded-lg placeholder:text-placeholder"
        />
      </div>

      <div className="flex gap-3">
        <Btn
          content={() => <p className="flex items-center justify-center gap-1"><UilArrowLeft size={16} /> {t('misc.back')}</p>}
          variant="outline"
          color="#1976D2"
          className="w-1/2 h-12 !rounded-full !border !border-border-lines"
          click={() => window.history.back()}
        />
        <div className="w-1/2">
          <FormBtn
            content={() => <span className="flex items-center justify-center gap-2">{t('registration.forgot_password.cta')} <ArrowRight size={16} /></span>}
            className="w-full h-12 rounded-full text-white bg-primary hover:bg-primary"
            disabled={!isValid || !isDirty}
            sx={{ '&.Mui-disabled': { backgroundColor: 'rgba(25, 118, 210, 0.5)', color: 'white' } }}
          />
        </div>
      </div>
    </div>
  )
})
